import { lazy } from "react";

export const GrapesJsEditor = lazy(() => import("./ui/grapes-js-editor"));
